import { useMemo } from 'react'

import BrawlCharacterHero from '@/assets/images/storefronts/brawlstars/bundle-character.png'
import BrawlHero1 from '@/assets/images/storefronts/brawlstars/bundle-hero1.png'
import BrawlHero2 from '@/assets/images/storefronts/brawlstars/bundle-hero2.png'

import { characterIds } from '../constants'

export const useBrawlHero = ({ character, index }: { character?: string; index: number }) => {
  if (character) {
    return BrawlCharacterHero
  }
  return [BrawlHero1, BrawlHero2].at(index) ?? BrawlHero1
}

export const brawlCharacterAsset = (id: string) => {
  return characterIds.includes(id)
}

export const useBrawlCharacterImage = (id?: string) => {
  return id ? `/images/brawlstars/characters/${id}.png` : null
}

export const useAssetColor = (id: string) => {
  return useMemo(() => {
    if (id === '5000000') return 'green'
    if (id === '5000022') return 'pink'
    if (id === '5000023') return 'purple'
    if (id === '5000001') return 'blue'
    if (brawlCharacterAsset(id)) return 'character'

    return 'yellow'
  }, [id])
}
